import { useEffect, useState } from "react";
import { ChevronRight, ChevronLeft, MessageSquare, Mail } from "lucide-react";
import api from "../lib/api";

export default function FloatingContact() {
  const [open, setOpen] = useState(true);
  const [cfg, setCfg] = useState({ whatsapp_number: "", imessage_number: "", support_email: "", contact_widget_active: false });

  useEffect(() => {
    api.get("/settings/public").then((r) => setCfg(r.data)).catch(() => {});
    const saved = localStorage.getItem("gs_contact_open");
    if (saved !== null) setOpen(saved === "1");
  }, []);

  const toggle = () => {
    const next = !open;
    setOpen(next);
    localStorage.setItem("gs_contact_open", next ? "1" : "0");
  };

  if (!cfg.contact_widget_active || (!cfg.whatsapp_number && !cfg.imessage_number && !cfg.support_email)) return null;

  const wa = cfg.whatsapp_number?.replace(/[^\d+]/g, "");
  const im = cfg.imessage_number?.replace(/[^\d+]/g, "");
  const mail = cfg.support_email;

  return (
    <div data-testid="floating-contact" className="fixed right-3 bottom-5 z-40 flex items-end pointer-events-none">
      <button
        data-testid="floating-contact-toggle"
        onClick={toggle}
        className="pointer-events-auto h-12 w-9 rounded-l-xl border border-r-0 border-[#1E293B] bg-[#0D0D12]/95 backdrop-blur-md flex items-center justify-center text-[#A1A1AA] hover:text-[#00FF66] transition-all self-end mb-0"
        aria-label={open ? "Hide contact" : "Show contact"}
        style={{ marginBottom: open ? 0 : 0 }}
      >
        {open ? <ChevronRight className="w-4 h-4" /> : <ChevronLeft className="w-4 h-4" />}
      </button>

      <div
        className={`pointer-events-auto origin-bottom-right transition-all duration-300 ${
          open ? "opacity-100 scale-100 translate-x-0" : "opacity-0 scale-90 translate-x-3 pointer-events-none w-0"
        }`}
        style={{ overflow: "hidden" }}
      >
        <div className="surface !rounded-l-xl !rounded-r-none border-r-0 overflow-hidden min-w-[230px]">
          <div className="px-4 py-2.5 border-b border-[#1E293B] bg-[#0a0a0c]">
            <div className="font-mono text-[10px] uppercase tracking-widest text-[#00FF66]">// contact us</div>
            <div className="text-xs text-[#A1A1AA] mt-0.5 font-body">we usually reply within minutes</div>
          </div>
          <div className="divide-y divide-[#1E293B]">
            {wa && (
              <a
                data-testid="contact-whatsapp"
                href={`https://wa.me/${wa.replace("+", "")}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 px-4 py-3 hover:bg-white/[0.03] group"
              >
                <span className="w-9 h-9 rounded-full flex items-center justify-center shrink-0" style={{ background: "#25D366" }}>
                  <svg viewBox="0 0 32 32" className="w-4 h-4 fill-white" aria-hidden="true">
                    <path d="M16.003 3.2C9.94 3.2 5 8.14 5 14.205c0 2.317.71 4.466 1.927 6.245L5 28l7.717-2.022a10.97 10.97 0 0 0 5.286 1.348c6.064 0 11.005-4.94 11.005-11.005S22.067 3.2 16.003 3.2zm6.49 15.74c-.275.778-1.605 1.49-2.224 1.55-.62.062-1.236.32-3.51-.85-2.92-1.5-4.766-4.6-4.91-4.79-.144-.193-1.184-1.59-1.184-3.03 0-1.44.74-2.15.997-2.44.257-.29.56-.36.747-.36.187 0 .374.001.537.01.172.008.404-.067.633.495.235.578.798 1.99.867 2.137.069.146.116.317.023.51-.092.193-.139.314-.276.483-.137.17-.288.378-.412.508-.137.146-.28.305-.12.6.16.293.71 1.27 1.527 2.06 1.05 1.013 1.937 1.327 2.232 1.474.295.146.466.122.638-.073.172-.196.732-.857.927-1.15.196-.293.39-.244.658-.146.27.097 1.71.806 2.005.952.295.147.49.22.564.343.073.123.073.71-.198 1.488z"/>
                  </svg>
                </span>
                <span className="font-mono text-xs text-[#A1A1AA] group-hover:text-[#25D366] transition-colors">whatsapp</span>
              </a>
            )}
            {im && (
              <a
                data-testid="contact-imessage"
                href={`sms:${im}`}
                className="flex items-center gap-3 px-4 py-3 hover:bg-white/[0.03] group"
              >
                <span className="w-9 h-9 rounded-full flex items-center justify-center shrink-0" style={{ background: "#007AFF" }}>
                  <MessageSquare className="w-4 h-4 text-white" />
                </span>
                <span className="font-mono text-xs text-[#A1A1AA] group-hover:text-[#007AFF] transition-colors">imessage</span>
              </a>
            )}
            {mail && (
              <a
                data-testid="contact-email"
                href={`mailto:${mail}`}
                className="flex items-center gap-3 px-4 py-3 hover:bg-white/[0.03] group"
              >
                <span className="w-9 h-9 rounded-full flex items-center justify-center shrink-0" style={{ background: "#00FF66" }}>
                  <Mail className="w-4 h-4 text-black" />
                </span>
                <span className="font-mono text-xs text-[#A1A1AA] group-hover:text-[#00FF66] transition-colors">email</span>
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
